// extracted by mini-css-extract-plugin
module.exports = {"ButtonLarge":"styles_ButtonLarge__4vk3V","content":"styles_content__gG_cG"};